import logo from './logo.svg';
import './App.css';
import './tailwind.css'
import MarzipanoViewer from './viewer';
import Viewer3D from './viewer_scripts/3dview/viewer';

function App() {
  return (
    <div className='overflow-hidden'>
{/* <Viewer3D></Viewer3D>       */}
      <MarzipanoViewer/>
    </div>
  );
}

export default App;
